import { render, staticRenderFns } from "./AICallAttributePicker.vue?vue&type=template&id=b569046c&scoped=true"
import script from "./AICallAttributePicker.vue?vue&type=script&lang=js"
export * from "./AICallAttributePicker.vue?vue&type=script&lang=js"
import style0 from "./AICallAttributePicker.vue?vue&type=style&index=0&id=b569046c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b569046c",
  null
  
)

export default component.exports